<template>
  <div
    class="filter"
    :class="[{ 'd-none': !showFilterX }, filterClass]"
  >
    <div class="header">
      <div class="flex justify-between items-center m-t-12">
        <h2>{{ $t("i18nCommon.Filter") }}</h2>
        <ms-icon
          icon="mi-close"
          :tooltip-content="$t('i18nCommon.Close')"
          :type-btn-icon="1"
          class="cursor-pointer"
          @click="clickClose()"
        />
      </div>
      <ms-input
        v-model="inputSearch"
        icon="mi-search"
        icon-pack="feature"
        :placeholder="$t('i18nCommon.Search')"
        :input-no-border="true"
        :icon-no-border="true"
        input-background=" #eeeff2"
        width="100%"
        height="35"
        style="margin-bottom: 7px"
      />
    </div>
    <div class="filter-condition">
      <template v-for="item in customOptions">
        <div
          v-show="
            item.dataName.toLowerCase().includes(inputSearch.toLowerCase())
          "
          :key="item.index"
          :class="{ 'checkedItem p-b-8': item.isChecked }"
          class="p-8 m-b-8 p-b-0"
        >
          <ms-checkbox
            v-model="item.isChecked"
            class="m-b-8"
            @input="onChangeCheckbox($event, item)"
          >
            {{ item.dataName }}
          </ms-checkbox>
          <div v-show="item.isChecked">
            <!--  Chọn ngày -->
            <ms-combobox
              v-if="item.filterType == 'date'"
              v-model="item.operator"
              :data="listOperatorDate"
              value-field="Value"
              display-field="Text"
              query-mode="local"
              class="m-b-8"
              :auto-set-first-item-when-empty="true"
              :use-i18n-value="true"
              @selected="changeCbDate($event, item)"
            />

            <!-- Chọn thời hạn -->
            <ms-combobox
              v-if="item.filterType == 'date-expired'"
              v-model="item.operator"
              :data="listOperatorDateExpired"
              value-field="Value"
              display-field="Text"
              query-mode="local"
              class="m-b-8"
              :auto-set-first-item-when-empty="true"
              :use-i18n-value="true"
              @selected="changeCbDate($event, item)"
            />

            <!--  cctc -->
            <ms-organization-unit
              v-if="item.filterType == 'organization-unit-multiple'"
              v-model="listOrg"
              mode="multiple"
              :name="'cctc'"
              :data="item.data"
              :init-item="OrgName"
              :autochild="false"
              :show-inactive="false"
              :show-clear-button="false"
              :show-option-no-choose="true"
              :is-use-empty-o-u-option="true"
              :use-i18n-value="item.queryMode == 'local'"
              @listData="changeOrgTree($event)"
            />

            <!------------------------------------------------------------------------------------------->

            <!-- date -->
            <div
              v-if="
                item.filterType == 'date' || item.filterType == 'date-expired'
              "
              v-show="item.showInput"
              :controlKey="'custom-filter-date-duration'"
            >
              <ms-datepicker
                v-model="item.fromDate"
                class="m-b-4"
                placeholder="dd/MM/yyyy"
                :append-to-body="true"
                @onChange="changeDatePicker($event, item)"
              />
              <ms-datepicker
                v-show="item.betweenDate"
                v-model="item.toDate"
                placeholder="dd/MM/yyyy"
                :append-to-body="true"
                @onChange="changeDatePicker($event, item)"
              />
              <div
                v-if="item.errorValidate"
                class="text-error m-t-4"
              >
                {{ $t("i18nCommon.INVALID_DATE_SELECTED") }}
              </div>
            </div>
            <!-- date-expired -->
            <!-- <div v-else-if="item.filterType == 'date-expired'" v-show="item.showInput">
              <ms-datepicker
                v-model="item.fromDate"
                class="m-b-4"
                placeholder="dd/MM/yyyy"
                :appendToBody="true"
                @onChange="changeDatePicker($event, item)"
              ></ms-datepicker>
              <ms-datepicker
                v-model="item.toDate"
                placeholder="dd/MM/yyyy"
                :appendToBody="true"
                @onChange="changeDatePicker($event, item)"
                v-show="item.betweenDate"
              ></ms-datepicker>
            </div> -->
            <!-- month -->
            <div
              v-else-if="item.filterType == 'month'"
              v-show="item.showInput"
            >
              <ms-datepicker
                v-model="item.fromDate"
                class="m-b-4"
                type="month"
                placeholder="MM/yyyy"
                :append-to-body="true"
                @onChange="changeDatePicker($event, item)"
              />
              <ms-datepicker
                v-show="item.betweenDate"
                v-model="item.toDate"
                class="m-b-4"
                type="month"
                placeholder="MM/yyyy"
                :append-to-body="true"
                @onChange="changeDatePicker($event, item)"
              />
            </div>
            <!-- datetime -->
            <ms-datepicker
              v-else-if="item.filterType == 'datetime'"
              v-show="item.showInput"
              v-model="item.inputValue"
              type="datetime"
              :append-to-body="true"
            />
            <!-- time -->
            <ms-datepicker
              v-else-if="item.filterType == 'time'"
              v-show="item.showInput"
              v-model="item.inputValue"
              type="time"
              :append-to-body="true"
            />
            <div
              v-else-if="item.filterType == 'ranged-date-time'"
              v-show="item.showInput"
            >
              <div>
                {{ $t("i18nCommon.From") }}
              </div>
              <ms-datepicker
                v-model="item.fromDate"
                class="m-b-4"
                :append-to-body="true"
                :placeholder="item.placeholderFormat || 'dd/MM/yyyy'"
                :type="item.dataType"
              />
              <div>
                {{ $t("i18nCommon.To") }}
              </div>
              <ms-datepicker
                v-model="item.toDate"
                class="m-b-4"
                :append-to-body="true"
                :placeholder="item.placeholderFormat || 'dd/MM/yyyy'"
                :type="item.dataType"
              />
            </div>
            <!-- year -->
            <ms-datepicker
              v-else-if="item.filterType == 'year'"
              v-show="item.showInput"
              v-model="item.inputValue"
              type="year"
              :append-to-body="true"
            />
            <!-- number -->
            <ms-number
              v-else-if="item.filterType == 'number'"
              v-show="item.showInput"
              v-model="item.inputValue"
              :is-spin="true"
            />
            <!-- combobox -->
            <!-- <ms-combobox
              v-else-if="item.filterType == 'combobox'"
              v-model="item.inputValue"
              :data="item.data"
              :valueField="item.valueField"
              :displayField="item.displayField"
              :queryMode="item.queryMode"
              :doQueryFuntion="getDoQueryFuntion(item)"
              :searchColums="item.searchColums"
              class="m-b-8"
              v-show="item.showInput"
              :initText="item.initText"
              @inputText="onChangeCombobox($event, item)"
              :useI18nValue="item.queryMode == 'local'"
            ></ms-combobox> -->
            <!-- combobox multiple -->
            <ms-combobox-multiple
              v-else-if="item.filterType == 'combobox-multiple'"
              v-show="item.showInput"
              v-model="item.inputValue"
              :data="item.data"
              :value-field="item.valueField"
              :display-field="item.displayField"
              :query-mode="item.queryMode"
              :do-query-funtion="getDoQueryFuntion(item)"
              :search-colums="item.searchColums"
              :init-items="item.initItems"
              :use-i18n-value="item.queryMode == 'local'"
              @selected="onChangeComboboxMultiple($event, item)"
            />

            <!-- combobox multiple avatar (Chọn người thực hiện) -->
            <ms-combobox-multiple
              v-else-if="item.filterType == 'combobox-multiple-custom-executer'"
              v-show="item.showInput"
              v-model="item.inputValue"
              :data="item.data"
              :value-field="item.valueField"
              :display-field="item.displayField"
              :query-mode="item.queryMode"
              :do-query-funtion="getDoQueryFuntion(item)"
              :search-colums="item.searchColums"
              :item-size="50"
              :init-items="item.initItems"
              @selected="onChangeComboboxMultiple($event, item)"
            >
              <template #item="slotData">
                <div class="user-custom-filter">
                  <div
                    class="user-avatar"
                    style="width: 32px; height: 32px; min-width: 32px"
                  >
                    <img
                      style="border-radius: 50%; width: 100%; height: 100%"
                      class="avatar-employee"
                      :src="slotData.data['Avatar']"
                    >
                  </div>
                  <div class="user-info wrap-text">
                    <span class="p-0 item-user-in-popup-filter">{{
                      slotData.data["ApproverName"]
                    }}</span>
                    <span
                      v-if="
                        slotData.data['ApproverOfficeEmail'] &&
                          slotData.data['ApproverEmail'].length != 0
                      "
                      class="p-0 item-user-in-popup-filter"
                    >
                      {{ slotData.data["ApproverOfficeEmail"] }}
                    </span>
                    <span
                      v-else
                      class="p-0 item-user-in-popup-filter"
                    >{{
                      slotData.data["ApproverEmail"]
                    }}</span>
                  </div>
                </div>
              </template>
            </ms-combobox-multiple>

            <!-- combobox multiple avatar (Chọn đối tượg kiến nghị) -->
            <!-- Chọn loại đối tượng -->
            <div v-else-if="item.filterType == 'combobox-multiple-custom-CreatBy'">
              <ms-combobox
                v-model="item.operator"
                :data="listOperatorOwner"
                value-field="Value"
                display-field="Text"
                query-mode="local"
                class="m-b-8"
                :auto-set-first-item-when-empty="true"
                :use-i18n-value="true"
                @selected="changeOwnerMode($event, item)"
              />
              <ms-combobox-multiple
                v-if="item.operator == filterComboboxEnumKey.Personal"
                v-model="item.inputValue"
                :data="item.data"
                :value-field="item.valueField"
                :display-field="item.displayField"
                :query-mode="item.queryMode"
                :do-query-funtion="getDoQueryFuntion(item)"
                :search-colums="item.searchColums"
                :item-size="45"
                :init-items="item.initItems"
                @selected="onChangeComboboxMultiple($event, item)"
              >
                <template #item="slotData">
                  <div class="user-custom-filter">
                    <div
                      class="user-avatar"
                      style="width: 32px; height: 32px; min-width: 32px"
                    >
                      <img
                        style="border-radius: 50%; width: 100%; height: 100%"
                        class="avatar-employee"
                        :src="slotData.data['Avatar']"
                      >
                    </div>
                    <div class="user-info">
                      <span class="p-0 item-user-in-popup-filter">{{
                        slotData.data["FullName"]
                      }}</span>
                      <span
                        v-if="
                          slotData.data['OfficeEmail'] &&
                            slotData.data['OfficeEmail'].length != 0
                        "
                        class="p-0 item-user-in-popup-filter"
                      >
                        {{ slotData.data["OfficeEmail"] }}
                      </span>
                      <span
                        v-else
                        class="p-0 item-user-in-popup-filter"
                      >{{
                        slotData.data["Email"]
                      }}</span>
                    </div>
                  </div>
                </template>
              </ms-combobox-multiple>
              <!-- mode là cơ cấu tổ chứ -->
              <ms-organization-unit
                v-if="item.operator == filterComboboxEnumKey.Unit"
                v-model="item.inputValue"
                :data="item.data"
                mode="single"
                :autochild="false"
                :show-inactive="false"
                :show-clear-button="false"
                :name="'cctc'"
                :init-item="item.initItems"
                :is-use-empty-o-u-option="true"
                @selected="changeOrgOwner($event, item)"
              />
            </div>
            <!-- input -->
            <ms-input
              v-else
              v-show="item.showInput"
              v-model="item.inputValue"
            />
          </div>
        </div>
      </template>
    </div>
    <div class="filter-button flex">
      <!-- Bỏ lọc -->
      <ms-button
        style="border: 1px solid #e3e5ee; width: 100px; margin-left: 6px"
        color="secondary"
        type="filled"
        @click="close"
      >
        {{ $t("i18nCommon.CancelFilter") }}
      </ms-button>
      <!-- Áp dụng -->
      <ms-button
        color="primary"
        type="filled"
        style="width: 100px"
        @click="handleApplyClick"
      >
        <span>{{ $t("i18nCommon.Apply") }}</span>
      </ms-button>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import _cloneDeep from "lodash/cloneDeep";
import FilterFunctionAPI from "./FilterFunctionAPI";
import DisplayEmployeeOnlyAvatar from "../ms-display-employee/DisplayEmployeeOnlyAvatar.vue";
import { formatDateTimeString, formatDateTimeString4 } from "./convertTime";
import { FilterComboboxEnumKey } from "@/models/enums/FilterEnum.js";
// import eventBusGlobal from "@/bus/eventBusGlobal.js";
import UserRoleAPI from "@/apis/components/UserRoleAPI.js";

export default {
  name: "MsFilter",
  components: {},
  props: {
    item: Object,
    options: Array,
    showFilter: {
      type: [Boolean, String],
      default: false,
    },
    filterCode: {
      type: String,
      default: "",
    },
    resetFilter: {
      type: Boolean,
      default: false,
    },
    filterClass: {
      type: String,
      default: "",
    },
    // có sử dụng fulltext search
    useFullTextSearch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      OrgName: "",
      filterCount: 0,
      FilterFunctionAPI: FilterFunctionAPI,
      isShowSaveFilterBtn: false,
      showFilterX: this.showFilter,
      filtersIDSearch: ["JobPositionIDsSearch", "OrganizationUnitIDsSearch"],
      customOptions: [],
      listOrg: [],
      dataEmployee: [],
      filterComboboxEnumKey: FilterComboboxEnumKey,
      listOperatorText: [
        {
          ID: 1,
          Text: "i18nCommon.Contain",
          Value: FilterComboboxEnumKey.Contains,
          ShowInput: true,
        },
        {
          ID: 5,
          Text: "i18nCommon.NotContain",
          Value: FilterComboboxEnumKey.Notcontains,
          ShowInput: true,
        },
        {
          ID: 2,
          Text: "i18nCommon.Equal",
          Value: FilterComboboxEnumKey.Equal,
          ShowInput: true,
        },
        {
          ID: 3,
          Text: "i18nCommon.StartSwith",
          Value: FilterComboboxEnumKey.Startswith,
          ShowInput: true,
        },
        {
          ID: 4,
          Text: "i18nCommon.EndSwith",
          Value: FilterComboboxEnumKey.Endswith,
          ShowInput: true,
        },
        {
          ID: 6,
          Text: "i18nCommon.Empty",
          Value: FilterComboboxEnumKey.Empty,
          ShowInput: false,
        },
        {
          ID: 7,
          Text: "i18nCommon.NotEmpty",
          Value: FilterComboboxEnumKey.NotEmpty,
          ShowInput: false,
        },
      ],
      listOperatorCombobox: [
        {
          ID: 1,
          Text: "i18nCommon.Equal",
          Value: FilterComboboxEnumKey.Equal,
          ShowInput: true,
        },
        {
          ID: 2,
          Text: "i18nCommon.Other",
          Value: FilterComboboxEnumKey.NotEqual,
          ShowInput: true,
        },
        {
          ID: 3,
          Text: "i18nCommon.Empty",
          Value: FilterComboboxEnumKey.Empty,
          ShowInput: false,
        },
        {
          ID: 4,
          Text: "i18nCommon.NotEmpty",
          Value: FilterComboboxEnumKey.NotEmpty,
          ShowInput: false,
        },
      ],
      listOperatorComboboxMultiple: [
        {
          ID: 1,
          Text: "i18nCommon.Equal",
          Value: FilterComboboxEnumKey.Equal,
          ShowInput: true,
        },
        {
          ID: 2,
          Text: "i18nCommon.Other",
          Value: FilterComboboxEnumKey.NotEqual,
          ShowInput: true,
        },
        {
          ID: 3,
          Text: "i18nCommon.Empty",
          Value: FilterComboboxEnumKey.Empty,
          ShowInput: false,
        },
        {
          ID: 4,
          Text: "i18nCommon.NotEmpty",
          Value: FilterComboboxEnumKey.NotEmpty,
          ShowInput: false,
        },
      ],
      listOperatorComboboxMultiple2: [
        {
          ID: 1,
          Text: "i18nCommon.Equal",
          Value: FilterComboboxEnumKey.Equal,
          ShowInput: true,
        },
        {
          ID: 2,
          Text: "i18nCommon.Other",
          Value: FilterComboboxEnumKey.NotEqual,
          ShowInput: true,
        },
      ],
      listOperatorNumber: [
        {
          ID: 1,
          Text: "i18nCommon.Equal",
          Value: FilterComboboxEnumKey.Equal,
          ShowInput: true,
        },
        {
          ID: 2,
          Text: "i18nCommon.Other",
          Value: FilterComboboxEnumKey.NotEqual,
          ShowInput: true,
        },
        {
          ID: 3,
          Text: "i18nCommon.Smaller",
          Value: FilterComboboxEnumKey.Less,
          ShowInput: true,
        },
        {
          ID: 4,
          Text: "i18nCommon.SmallerOrEqual",
          Value: FilterComboboxEnumKey.LessAndEqual,
          ShowInput: true,
        },
        {
          ID: 5,
          Text: "i18nCommon.Higher",
          Value: FilterComboboxEnumKey.Greater,
          ShowInput: true,
        },
        {
          ID: 6,
          Text: "i18nCommon.HigherOrEqual",
          Value: FilterComboboxEnumKey.GreaterAndEqual,
          ShowInput: true,
        },
        {
          ID: 7,
          Text: "i18nCommon.Empty",
          Value: FilterComboboxEnumKey.Empty,
          ShowInput: false,
        },
        {
          ID: 8,
          Text: "i18nCommon.NotEmpty",
          Value: FilterComboboxEnumKey.NotEmpty,
          ShowInput: false,
        },
      ],
      listOperatorDate: [
        // {
        //   ID: 1,
        //   Text: "i18nCommon.Equal",
        //   Value: FilterComboboxEnumKey.Equal,
        //   ShowInput: true,
        // },
        // {
        //   ID: 2,
        //   Text: "i18nCommon.Other",
        //   Value: FilterComboboxEnumKey.NotEqual,
        //   ShowInput: true,
        // },
        // {
        //   ID: 3,
        //   Text: "i18nCommon.Smaller",
        //   Value: FilterComboboxEnumKey.Less,
        //   ShowInput: true,
        // },
        // {
        //   ID: 4,
        //   Text: "i18nCommon.SmallerOrEqual",
        //   Value: FilterComboboxEnumKey.LessAndEqual,
        //   ShowInput: true,
        // },
        // {
        //   ID: 5,
        //   Text: "i18nCommon.Higher",
        //   Value: FilterComboboxEnumKey.Greater,
        //   ShowInput: true,
        // },
        // {
        //   ID: 6,
        //   Text: "i18nCommon.HigherOrEqual",
        //   Value: FilterComboboxEnumKey.GreaterAndEqual,
        //   ShowInput: true,
        // },
        // {
        //   ID: 7,
        //   Text: "i18nCommon.Empty",
        //   Value: FilterComboboxEnumKey.Empty,
        //   ShowInput: false,
        // },
        // {
        //   ID: 8,
        //   Text: "i18nCommon.NotEmpty",
        //   Value: FilterComboboxEnumKey.NotEmpty,
        //   ShowInput: false,
        // },
        {
          ID: 9,
          Text: "i18nCommon.ToDay",
          Value: FilterComboboxEnumKey.Today,
          ShowInput: false,
        },
        {
          ID: 10,
          Text: "i18nCommon.ThisWeek",
          Value: FilterComboboxEnumKey.ThisWeek,
          ShowInput: false,
        },
        {
          ID: 11,
          Text: "i18nCommon.ThisMonth",
          Value: FilterComboboxEnumKey.ThisMonth,
          ShowInput: false,
        },
        {
          ID: 12,
          Text: "i18nCommon.ThisYear",
          Value: FilterComboboxEnumKey.ThisYear,
          ShowInput: false,
        },
        // {
        //   ID: 13,
        //   Text: "i18nCommon.Yesterday",
        //   Value: FilterComboboxEnumKey.Yesterday,
        //   ShowInput: false,
        // },
        {
          ID: 14,
          Text: "i18nCommon.PreviousWeek",
          Value: FilterComboboxEnumKey.PreviousWeek,
          ShowInput: false,
        },
        {
          ID: 15,
          Text: "i18nCommon.PreviousMonth",
          Value: FilterComboboxEnumKey.PreviousMonth,
          ShowInput: false,
        },
        // {
        //   ID: 16,
        //   Text: "i18nCommon.PreviousYear",
        //   Value: FilterComboboxEnumKey.PreviousYear,
        //   ShowInput: false,
        // },
        // {
        //   ID: 17,
        //   Text: "i18nCommon.Tomorrow",
        //   Value: FilterComboboxEnumKey.Tomorrow,
        //   ShowInput: false,
        // },
        // {
        //   ID: 18,
        //   Text: "i18nCommon.NextWeek",
        //   Value: FilterComboboxEnumKey.NextWeek,
        //   ShowInput: false,
        // },
        // {
        //   ID: 19,
        //   Text: "i18nCommon.NextMonth",
        //   Value: FilterComboboxEnumKey.NextMonth,
        //   ShowInput: false,
        // },
        {
          ID: 20,
          Text: "i18nCommon.NextYear",
          Value: FilterComboboxEnumKey.NextYear,
          ShowInput: false,
        },
        {
          ID: 21,
          Text: "i18nCommon.CHOOSE_TIME",
          Value: FilterComboboxEnumKey.Between,
          ShowInput: true,
          BetweenDate: true,
        },
      ],
      listOperatorDateExpired: [
        {
          ID: 1,
          Text: "i18nCommon.UnExpired",
          Value: FilterComboboxEnumKey.UnExpired,
          ShowInput: false,
        },
        {
          ID: 2,
          Text: "i18nCommon.Expired",
          Value: FilterComboboxEnumKey.Expired,
          ShowInput: false,
        },
        {
          ID: 3,
          Text: "i18nCommon.CHOOSE_TIME",
          Value: FilterComboboxEnumKey.Between,
          ShowInput: true,
          BetweenDate: true,
        },
      ],
      listOperatorOwner: [
        {
          ID: 1,
          Text: "i18nCommon.Personal",
          Value: FilterComboboxEnumKey.Personal,
        },
        {
          ID: 2,
          Text: "i18nCommon.Unit",
          Value: FilterComboboxEnumKey.Unit,
        },
      ],
      listOperatorTime: [
        {
          ID: 1,
          Text: "i18nCommon.Equal",
          Value: FilterComboboxEnumKey.Equal,
          ShowInput: true,
        },
        {
          ID: 2,
          Text: "i18nCommon.Other",
          Value: FilterComboboxEnumKey.NotEqual,
          ShowInput: true,
        },
        {
          ID: 3,
          Text: "i18nCommon.Smaller",
          Value: FilterComboboxEnumKey.Less,
          ShowInput: true,
        },
        {
          ID: 4,
          Text: "i18nCommon.SmallerOrEqual",
          Value: FilterComboboxEnumKey.LessAndEqual,
          ShowInput: true,
        },
        {
          ID: 5,
          Text: "i18nCommon.Higher",
          Value: FilterComboboxEnumKey.Greater,
          ShowInput: true,
        },
        {
          ID: 6,
          Text: "i18nCommon.HigherOrEqual",
          Value: FilterComboboxEnumKey.GreaterAndEqual,
          ShowInput: true,
        },
        {
          ID: 7,
          Text: "i18nCommon.Empty",
          Value: FilterComboboxEnumKey.Empty,
          ShowInput: false,
        },
        {
          ID: 8,
          Text: "i18nCommon.NotEmpty",
          Value: FilterComboboxEnumKey.NotEmpty,
          ShowInput: false,
        },
        {
          ID: 8,
          Text: "i18nCommon.Between",
          Value: FilterComboboxEnumKey.Between,
          ShowInput: true,
          BetweenDate: true,
        },
      ],
      listOperatorMonth: [
        {
          ID: 1,
          Text: "i18nCommon.Equal",
          Value: FilterComboboxEnumKey.Equal,
          ShowInput: true,
        },
        {
          ID: 2,
          Text: "i18nCommon.Other",
          Value: FilterComboboxEnumKey.NotEqual,
          ShowInput: true,
        },
        {
          ID: 3,
          Text: "i18nCommon.Smaller",
          Value: FilterComboboxEnumKey.Less,
          ShowInput: true,
        },
        {
          ID: 4,
          Text: "i18nCommon.SmallerOrEqual",
          Value: FilterComboboxEnumKey.LessAndEqual,
          ShowInput: true,
        },
        {
          ID: 5,
          Text: "i18nCommon.Higher",
          Value: FilterComboboxEnumKey.Greater,
          ShowInput: true,
        },
        {
          ID: 6,
          Text: "i18nCommon.HigherOrEqual",
          Value: FilterComboboxEnumKey.GreaterAndEqual,
          ShowInput: true,
        },
        {
          ID: 7,
          Text: "i18nCommon.Empty",
          Value: FilterComboboxEnumKey.Empty,
          ShowInput: false,
        },
        {
          ID: 8,
          Text: "i18nCommon.NotEmpty",
          Value: FilterComboboxEnumKey.NotEmpty,
          ShowInput: false,
        },
        {
          ID: 9,
          Text: "i18nCommon.ThisMonth",
          Value: FilterComboboxEnumKey.ThisMonth,
          ShowInput: false,
        },
        {
          ID: 10,
          Text: "i18nCommon.ThisYear",
          Value: FilterComboboxEnumKey.ThisYear,
          ShowInput: false,
        },
        {
          ID: 11,
          Text: "i18nCommon.PreviousMonth",
          Value: FilterComboboxEnumKey.PreviousMonth,
          ShowInput: false,
        },
        {
          ID: 12,
          Text: "i18nCommon.PreviousYear",
          Value: FilterComboboxEnumKey.PreviousYear,
          ShowInput: false,
        },
        {
          ID: 13,
          Text: "i18nCommon.NextMonth",
          Value: FilterComboboxEnumKey.NextMonth,
          ShowInput: false,
        },
        {
          ID: 14,
          Text: "i18nCommon.NextYear",
          Value: FilterComboboxEnumKey.NextYear,
          ShowInput: false,
        },
        {
          ID: 15,
          Text: "i18nCommon.Between",
          Value: FilterComboboxEnumKey.Between,
          ShowInput: true,
          BetweenDate: true,
        },
      ],
      listOperatorBool: [
        {
          ID: 1,
          Text: "i18nCommon.Equal",
          Value: FilterComboboxEnumKey.Equal,
          ShowInput: true,
        },
        {
          ID: 2,
          Text: "i18nCommon.Other",
          Value: FilterComboboxEnumKey.NotEqual,
          ShowInput: true,
        },
      ],
      inputSearch: "",
    };
  },
  computed: {
    /**
     * Hàm lấy operator full text search dựa trên biến useFullTextSearch
     * created by pdthien
     */
    getOperatorFullTextSearch() {
      if (!this.useFullTextSearch) {
        return "in";
      }
      return "ft";
    },
    /**
     * Hàm lấy operator not full text search dựa trên biến useFullTextSearch
     * created by pdthien
     */
    getOperatorNotFullTextSearch() {
      if (!this.useFullTextSearch) {
        return "notin";
      }
      return "notft";
    },
  },
  watch: {
    showFilter(val) {
      this.showFilterX = val;
    },
    options: {
      immediate: true,
      deep: true,
      handler(val) {
        val && val.length > 0 && this.initOptions();
      },
    },
  },
  async created() {
    this.$bus.$on("clearFilter", () => {
      this.close();
    });
    // this.getEmployee();
  },
  methods: {
    /**
     * Hàm lấy operator khi khởi tạo filter
     * created by pdthien 28.04.2021
     */
    getInitOperatorCombo(filterType) {
      var res = null;
      switch (filterType) {
        case "date":
          res = this.listOperatorDate[0];
          break;
        case "date-expired":
          res = this.listOperatorDateExpired[0];
          break;
        case "time":
          res = this.listOperatorTime[0];
          break;
        case "month":
          res = this.listOperatorMonth[0];
          break;
        case "bool":
          res = this.listOperatorBool[0];
          break;
        case "number":
          res = this.listOperatorNumber[0];
          break;
        case "position-apply":
        case "employee-apply":
          res = this.listOperatorComboboxMultiple2[0];
          break;
        case "combobox-multiple":
          res = this.listOperatorComboboxMultiple[0];
          break;
        case "combobox":
          res = this.listOperatorCombobox[0];
          break;
        default:
          res = this.listOperatorText[0];
          break;
      }
      return res;
    },
    getEmployee() {
      let pagingUser = {
        PageSize: 15,
        PageIndex: 1,
      };
      let me = this;
      UserRoleAPI.getUserPagingByAppCode(pagingUser).then((result) => {
        if (result) {
          if (result.data.Success && result.data.Data) {
            me.dataEmployee = result.data.Data.PageData;
          } else {
            resolve({
              SummaryData: null,
              PageData: [],
              Total: 0,
              CustomData: null,
            });
          }
        }
      });
    },
    /**
     * Hàm xử lý filter ngay khi người dùng chọn các điều kiện lọc không cần nhập giá trị
     * created pdthien 31.03.2021
     */
    handleSelectDirect(operator) {
      switch (operator) {
        case FilterComboboxEnumKey.Empty:
        case FilterComboboxEnumKey.NotEmpty:
        case FilterComboboxEnumKey.Today:
        case FilterComboboxEnumKey.ThisWeek:
        case FilterComboboxEnumKey.ThisMonth:
        case FilterComboboxEnumKey.ThisYear:
        case FilterComboboxEnumKey.Yesterday:
        case FilterComboboxEnumKey.PreviousWeek:
        case FilterComboboxEnumKey.PreviousMonth:
        case FilterComboboxEnumKey.PreviousYear:
        case FilterComboboxEnumKey.Tomorrow:
        case FilterComboboxEnumKey.NextWeek:
        case FilterComboboxEnumKey.NextMonth:
        case FilterComboboxEnumKey.NextYear:
        case FilterComboboxEnumKey.Expired:
        case FilterComboboxEnumKey.UnExpired:
          // this.handleApplyClick();
          break;
      }
    },
    /**
     * Hàm lấy hàm query
     * LTHAI(19/2/2021)
     */
    getDoQueryFuntion(item) {
      if (this.isFunction(item.doQueryFuntion)) {
        return item.doQueryFuntion;
      } else {
        return this.FilterFunctionAPI[item.doQueryFuntion];
      }
    },
    /**
     * Hàm kiểm tra có phải func không
     * LTHAI(19/2/2021)
     */
    isFunction(functionToCheck) {
      return (
        functionToCheck &&
        {}.toString.call(functionToCheck) === "[object Function]"
      );
    },
    /**
     * cơ cấu tổ chức
     * pmhieu 18/09/2021
     */
    changeOrgTree(e) {
      if (!e || (e && e.IsOptionNoChoose)) {
        this.listOrg = e;
      }
    },
    /**
     * cơ cấu tổ chức đối tượng kiến nghị
     */
    changeOrgOwner(e, item) {
      if (e) {
        item.initItems = e.OrganizationUnitName;
      }
    },
    changeOwnerMode(val, item) {
      item.operator = val.newData.Value;
      item.initItems =
        val.newData.Value == this.filterComboboxEnumKey.Unit ? "" : [];
      item.inputValue = null;
    },
    /**
     * Hàm bỏ lọc
     */
    close() {
      this.clickClose(true);
      if (this.filterCount > 0) {
        this.saveFilter([]);
        this.$emit("disabledFilter");
      }
      this.filterCount = 0;
      // reset lại giá trị filter
      let optionsTemp = this.$function._cloneDeep(this.options);
      this.customOptions = [];
      optionsTemp.forEach((o, index) => {
        // khi đóng msfilter, lưu lại giá trị customOptions
        this.customOptions.push({
          ...o,
          index: index,
          isChecked: false,
          operator: o.operator || this.getInitOperatorCombo(o.filterType).Value,
          operatorName:
            o.operatorName || this.getInitOperatorCombo(o.filterType).Text,
          inputValue: o.inputValue ? o.inputValue : null,
          inputValueCustom: o.inputValueCustom ? o.inputValueCustom : null,
          fromDate:
            new Date(o.fromDate) || this.filterType == "month"
              ? new Date(new Date().setDate(1))
              : new Date(),
          toDate:
            new Date(o.toDate) || this.filterType == "month"
              ? new Date(new Date().setDate(1))
              : new Date(),
          filterType: o.filterType || null,
          showInput: o.showInput || true,
          filterID: o.filterID ? o.filterID : o.valueField,
          doQueryFuntion: null,
          initText: null,
          initItems: null,
        });
      });
    },
    /**
     * Hàm gọi khi xóa item trên top bar lọc bên BaseContentArea
     * created by pdthien 19.03.2021
     */
    handleRemoveItemFilter(index) {
      let item = this.customOptions.find((e) => e.index == index);
      this.onChangeCheckbox(false, item);
      this.handleApplyClick();
    },
    /**
     * Hàm tạo fulltext search cho vị trí công việc
     * created by pdthien
     */
    genFullTextForJobPosition(arr) {
      let res = "";
      arr.forEach((e) => {
        if (this.useFullTextSearch) {
          res += `a${e}a;`;
        } else {
          res += `${e};`;
        }
      });
      return res.slice(0, res.length - 1);
    },
    /**
     * Hàm áp dụng filter và emit ra giá trị của đã chọn
     * pdthien 21.09.2020
     * modified by nvcuong1: 3.11.2021
     */
    handleApplyClick(saveFilter = true, callAPI = true) {
      let self = this;
      let generatedOptions = [];
      let listFilter = this.customOptions.filter((e) => e.isChecked);
      let filter = listFilter.length > 0 ? "[" : "";
      if (listFilter && listFilter.length > 0) {
        listFilter.forEach((item, i) => {
          if (item.filterType == "organization-unit-multiple") {
            item.inputValue = self.listOrg;
          }
          // TH filter không phải loại date hoặc month
          if (
            item.filterType != "date" &&
            item.filterType != "month" &&
            item.filterType != "ranged-date-time"
          ) {
            // Nếu operator không là Trống và Không trống
            if (
              item.operator != FilterComboboxEnumKey.Empty &&
              item.operator != FilterComboboxEnumKey.NotEmpty
            ) {
              // listFilter > 1
              if (i < listFilter.length - 1) {
                // TH filter loại combobox multiple hoặc loại vị trí công việc + multiple, nhân viên áp dụng
                if (
                  item.filterType == "combobox-multiple" ||
                  (item.filterType == "position-apply" &&
                    (item.multiple || typeof item.multiple != "boolean")) ||
                  item.filterType == "employee-apply"
                ) {
                  if (
                    item.filterType == "combobox-multiple" ||
                    (item.inputValue &&
                      item.inputValue.length > 0 &&
                      (item.filterType == "position-apply" ||
                        item.filterType == "employee-apply"))
                  ) {
                    // TH filterID là JobPositionIDsSearch hoặc OrganizationUnitIDsSearch
                    if (self.filtersIDSearch.includes(item.filterID)) {
                      filter += `[["${item.filterID}", "${
                        item.operator == FilterComboboxEnumKey.Equal
                          ? self.getOperatorFullTextSearch
                          : self.getOperatorNotFullTextSearch
                      }", "${
                        item.inputValue && item.inputValue.length > 0
                          ? self.genFullTextForJobPosition(item.inputValue)
                          : ""
                      }"], "OR", ["${item.filterID}", "=", ""]], "AND",`;
                    } else {
                      filter += `["${item.filterID}", "${
                        item.operator == FilterComboboxEnumKey.Equal
                          ? self.getOperatorFullTextSearch
                          : self.getOperatorNotFullTextSearch
                      }", "${
                        item.inputValue && item.inputValue.length > 0
                          ? item.inputValue.join(";")
                          : ""
                      }"], "AND",`;
                    }
                  } else {
                    // TH combox loại vị trí công việc hoặc nhân viên áp dụng khi giá trị null hoặc rỗng
                    if (
                      !item.inputValue &&
                      (item.filterType == "position-apply" ||
                        item.filterType == "employee-apply")
                    ) {
                      if (item.operator == FilterComboboxEnumKey.NotEqual) {
                        filter += `["${item.filterID}", "notnull"], "AND",`;
                      } else {
                        // filter += `[1, "=", 1], "AND",`;
                      }
                    }
                  }

                  if (item.filterType == "position-apply" && !item.inputValue) {
                    item.inputValueCustom = this.$t(
                      "i18nPayroll.Advance.AllJobPositions"
                    );
                  }
                  if (item.filterType == "employee-apply" && !item.inputValue) {
                    item.inputValueCustom = this.$t("i18nCommon.AllEmployees");
                  }
                  generatedOptions.push({
                    renderItemTitle: `${
                      item.dataName
                    } ${self.$function.handleLocalize(item.operatorName)} ${
                      self.$function.handleLocalize(item.inputValueCustom) ||
                      '"' + this.$t("i18nCommon.None") + '"'
                    }`,
                    renderItem: `<b>${
                      item.dataName
                    }</b> ${self.$function.handleLocalize(
                      item.operatorName
                    )} <b>${
                      self.$function.handleLocalize(item.inputValueCustom) ||
                      '"' + this.$t("i18nCommon.None") + '"'
                    }</b>`,
                    item: item,
                  });
                }
                // TH filter loại combobox multiple hoặc loại vị trí công việc + single
                else if (
                  item.filterType == "combobox" ||
                  (item.filterType == "position-apply" && !item.multiple) ||
                  (item.filterType == "employee-apply" && !item.multiple)
                ) {
                  filter += `["${item.filterID}", "${item.operator}", "${
                    item.inputValue ||
                    item.inputValue === 0 ||
                    item.inputValue === "0"
                      ? item.inputValue.toString().replace(/"/g, "'")
                      : ""
                  }"], "AND",`;
                  generatedOptions.push({
                    renderItemTitle: `${
                      item.dataName
                    } ${self.$function.handleLocalize(item.operatorName)} ${
                      self.$function.handleLocalize(item.inputValueCustom) ||
                      '"' + this.$t("i18nCommon.None") + '"'
                    }`,
                    renderItem: `<b>${
                      item.dataName
                    }</b> ${self.$function.handleLocalize(
                      item.operatorName
                    )} <b>${
                      self.$function.handleLocalize(item.inputValueCustom) ||
                      '"' + this.$t("i18nCommon.None") + '"'
                    }</b>`,
                    item: item,
                  });
                }
                // TH còn lại
                else {
                  // TH số
                  if (item.filterType == "number" && !item.inputValue)
                    item.inputValue = 0;
                  filter += `["${item.filterID}", "${item.operator}", "${
                    item.inputValue || String(item.inputValue) == "0"
                      ? item.inputValue.toString().replace(/"/g, "'")
                      : ""
                  }"], "AND",`;
                  generatedOptions.push({
                    renderItemTitle: `${
                      item.dataName
                    } ${self.$function.handleLocalize(item.operatorName)} ${
                      item.inputValue || String(item.inputValue) == "0"
                        ? item.inputValue
                        : `"${this.$t("i18nCommon.None")}"`
                    }`,
                    renderItem: `<b>${
                      item.dataName
                    }</b> ${self.$function.handleLocalize(
                      item.operatorName
                    )} <b>${
                      item.inputValue || String(item.inputValue) == "0"
                        ? item.inputValue
                        : `"${this.$t("i18nCommon.None")}"`
                    }</b>`,
                    item: item,
                  });
                }
              }
              // listFilter <= 1
              else {
                // TH filter loại combobox multiple hoặc loại vị trí công việc + multiple, nhân viên áp dụng
                if (
                  item.filterType == "combobox-multiple" ||
                  (item.filterType == "position-apply" &&
                    (item.multiple || typeof item.multiple != "boolean")) ||
                  item.filterType == "employee-apply"
                ) {
                  if (
                    item.filterType == "combobox-multiple" ||
                    (item.inputValue &&
                      item.inputValue.length > 0 &&
                      (item.filterType == "position-apply" ||
                        item.filterType == "employee-apply"))
                  ) {
                    // TH filterID là JobPositionIDsSearch hoặc OrganizationUnitIDsSearch
                    if (self.filtersIDSearch.includes(item.filterID)) {
                      filter += `[["${item.filterID}", "${
                        item.operator == FilterComboboxEnumKey.Equal
                          ? self.getOperatorFullTextSearch
                          : self.getOperatorNotFullTextSearch
                      }", "${
                        item.inputValue && item.inputValue.length > 0
                          ? self.genFullTextForJobPosition(item.inputValue)
                          : ""
                      }"], "OR", ["${item.filterID}", "=", ""]]`;
                    } else {
                      filter += `["${item.filterID}", "${
                        item.operator == FilterComboboxEnumKey.Equal
                          ? self.getOperatorFullTextSearch
                          : self.getOperatorNotFullTextSearch
                      }", "${
                        item.inputValue && item.inputValue.length > 0
                          ? item.inputValue.join(";")
                          : ""
                      }"]`;
                    }
                  } else {
                    // TH combox loại vị trí công việc hoặc nhân viên áp dụng khi giá trị null hoặc rỗng
                    if (
                      !item.inputValue &&
                      (item.filterType == "position-apply" ||
                        item.filterType == "employee-apply")
                    ) {
                      if (item.operator == FilterComboboxEnumKey.NotEqual) {
                        filter += `["${item.filterID}", "notnull"]`;
                      } else {
                        // bỏ kí tự and ở cuối
                        filter += filter.slice(0, filter.length - 8);
                      }
                    }
                  }
                  if (item.filterType == "position-apply" && !item.inputValue) {
                    item.inputValueCustom = this.$t(
                      "i18nPayroll.Advance.AllJobPositions"
                    );
                  }
                  if (item.filterType == "employee-apply" && !item.inputValue) {
                    item.inputValueCustom = this.$t("i18nCommon.AllEmployees");
                  }
                  generatedOptions.push({
                    renderItemTitle: `${
                      item.dataName
                    } ${self.$function.handleLocalize(item.operatorName)} ${
                      self.$function.handleLocalize(item.inputValueCustom) ||
                      '"' + this.$t("i18nCommon.None") + '"'
                    }`,
                    renderItem: `<b>${
                      item.dataName
                    }</b> ${self.$function.handleLocalize(
                      item.operatorName
                    )} <b>${
                      self.$function.handleLocalize(item.inputValueCustom) ||
                      '"' + this.$t("i18nCommon.None") + '"'
                    }</b>`,
                    item: item,
                  });
                }
                // TH filter loại combobox multiple hoặc loại vị trí công việc + single
                else if (
                  item.filterType == "combobox" ||
                  (item.filterType == "position-apply" && !item.multiple) ||
                  (item.filterType == "employee-apply" && !item.multiple)
                ) {
                  filter += `["${item.filterID}", "${item.operator}", "${
                    item.inputValue ||
                    item.inputValue === 0 ||
                    item.inputValue === "0"
                      ? item.inputValue.toString().replace(/"/g, "'")
                      : ""
                  }"]`;
                  generatedOptions.push({
                    renderItemTitle: `${
                      item.dataName
                    } ${self.$function.handleLocalize(item.operatorName)} ${
                      self.$function.handleLocalize(item.inputValueCustom) ||
                      '"' + this.$t("i18nCommon.None") + '"'
                    }`,
                    renderItem: `<b>${
                      item.dataName
                    }</b> ${self.$function.handleLocalize(
                      item.operatorName
                    )} <b>${
                      self.$function.handleLocalize(item.inputValueCustom) ||
                      '"' + this.$t("i18nCommon.None") + '"'
                    }</b>`,
                    item: item,
                  });
                }
                // TH còn lại
                else {
                  // TH số
                  if (item.filterType == "number" && !item.inputValue)
                    item.inputValue = 0;
                  filter += `["${item.filterID}", "${item.operator}", "${
                    item.inputValue || String(item.inputValue) == "0"
                      ? item.inputValue.toString().replace(/"/g, "'")
                      : ""
                  }"]`;
                  generatedOptions.push({
                    renderItemTitle: `${
                      item.dataName
                    } ${self.$function.handleLocalize(item.operatorName)} ${
                      item.inputValue || String(item.inputValue) == "0"
                        ? item.inputValue
                        : `"${this.$t("i18nCommon.None")}"`
                    }`,
                    renderItem: `<b>${
                      item.dataName
                    }</b> ${self.$function.handleLocalize(
                      item.operatorName
                    )} <b>${
                      item.inputValue || String(item.inputValue) == "0"
                        ? item.inputValue
                        : `"${this.$t("i18nCommon.None")}"`
                    }</b>`,
                    item: item,
                  });
                }
              }
            }
            // Nếu operator là Trống hoặc Không trống
            else {
              // Nếu operator là Trống
              if (item.operator == FilterComboboxEnumKey.Empty) {
                if (i < listFilter.length - 1) {
                  filter += `["${item.filterID}", "isnull"], "AND",`;
                } else {
                  filter += `["${item.filterID}", "isnull"]`;
                }
                generatedOptions.push({
                  renderItemTitle: `${item.dataName} ${this.$t(
                    "i18nCommon.Equal"
                  )} "${this.$t("i18nCommon.Empty")}"`,
                  renderItem: `<b>${item.dataName}</b> ${this.$t(
                    "i18nCommon.Equal"
                  )} <b>"${this.$t("i18nCommon.Empty")}"</b>`,
                  item: item,
                });
              }
              // Nếu operator là Không trống
              else if (item.operator == FilterComboboxEnumKey.NotEmpty) {
                if (i < listFilter.length - 1) {
                  filter += `["${item.filterID}", "notnull"], "AND",`;
                } else {
                  filter += `["${item.filterID}", "notnull"]`;
                }
                generatedOptions.push({
                  renderItemTitle: `${item.dataName} ${this.$t(
                    "i18nCommon.Equal"
                  )} "${this.$t("i18nCommon.NotEmpty")}"`,
                  renderItem: `<b>${item.dataName}</b> ${this.$t(
                    "i18nCommon.Equal"
                  )} <b>"${this.$t("i18nCommon.NotEmpty")}"</b>`,
                  item: item,
                });
              }
            }
          }
          // Trường hợp filter là loại khoảng thời gian
          else if (item.filterType == "ranged-date-time") {
            const fromDate = item.fromDate;
            const toDate = item.toDate;
            // reset thời gian về 0h nếu dataType không phải là kiểu thời gian
            if (item.dataType && item.dataType !== "time") {
              fromDate.setHours(0, 0, 0);
              toDate.setHours(0, 0, 0);
            }
            // format chuỗi hiện thị trên header filter
            let fromDateString = moment(fromDate).format("DD/MM/YYYY");
            let toDateString = moment(toDate).format("DD/MM/YYYY");
            let fromDateFilter = moment(item.fromDate).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            let toDateFilter = moment(item.toDate).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            item.operatorName = this.$t("i18nCommon.between");
            let activeFilterTextTitle = `${item.dataName} ${this.$t(
              "i18nCommon.From"
            )} ${fromDateString} ${this.$t("i18nCommon.To")} ${toDateString}`;
            let activeFilterText = `<b>${item.dataName}</b> ${this.$t(
              "i18nCommon.From"
            )} <b>${fromDateString}</b> ${this.$t(
              "i18nCommon.To"
            )} <b>${toDateString}</b>`;
            // chuỗi tooltip trên header filter
            item.inputValueCustom = `${this.$t(
              "i18nCommon.From"
            )} ${fromDateString} ${this.$t("i18nCommon.To")} ${toDateString}`;
            // Khởi tạo filter
            filter += `["${item.startValueField}", ">=", "${fromDateFilter}"], "AND", ["${item.endValueField}", "<=", "${toDateFilter}"]`;
            if (i < listFilter.length - 1) {
              filter += `, "AND",`;
            }
            generatedOptions.push({
              renderItemTitle: activeFilterTextTitle,
              renderItem: activeFilterText,
              item: item,
            });
          }
          // TH filter loại date
          else {
            // Nếu operator không là Trống và Không trống và là Trong khoảng
            if (
              item.operator != FilterComboboxEnumKey.Empty &&
              item.operator != FilterComboboxEnumKey.NotEmpty
            ) {
              if (
                item.operator == FilterComboboxEnumKey.Equal ||
                item.operator == FilterComboboxEnumKey.NotEqual ||
                item.operator == FilterComboboxEnumKey.Less ||
                item.operator == FilterComboboxEnumKey.LessAndEqual ||
                item.operator == FilterComboboxEnumKey.Greater ||
                item.operator == FilterComboboxEnumKey.GreaterAndEqual
              ) {
                item.toDate = item.fromDate;
              }
              if (item.fromDate && item.fromDate != "Invalid Date") {
                item.fromDate = new Date(item.fromDate.setHours(0, 0, 0, 0));
                item.toDate = new Date(item.toDate.setHours(23, 59, 59, 59));
                switch (item.filterType) {
                  case "date":
                    item.inputValueCustom = formatDateTimeString(item.fromDate);
                    break;
                  case "datetime":
                    break;
                  case "month":
                    item.fromDate = new Date(item.fromDate.setDate(1));
                    item.toDate = new Date(
                      item.toDate.getFullYear(),
                      item.toDate.getMonth() + 1,
                      0
                    );
                    item.inputValueCustom = formatDateTimeString4(
                      item.fromDate
                    );
                    break;
                  case "time":
                    break;
                }

                switch (item.operator) {
                  case FilterComboboxEnumKey.Today:
                    item.inputValueCustom = this.$t("i18nCommon.ToDay");
                    break;
                  case FilterComboboxEnumKey.ThisWeek:
                    item.inputValueCustom = this.$t("i18nCommon.ThisWeek");
                    break;
                  case FilterComboboxEnumKey.ThisMonth:
                    item.inputValueCustom = this.$t("i18nCommon.ThisMonth");
                    break;
                  case FilterComboboxEnumKey.ThisYear:
                    item.inputValueCustom = this.$t("i18nCommon.ThisYear");
                    break;
                  case FilterComboboxEnumKey.Yesterday:
                    item.inputValueCustom = this.$t("i18nCommon.Yesterday");
                    break;
                  case FilterComboboxEnumKey.PreviousWeek:
                    item.inputValueCustom = this.$t("i18nCommon.LastWeek");
                    break;
                  case FilterComboboxEnumKey.PreviousMonth:
                    item.inputValueCustom = this.$t("i18nCommon.LastMonth");
                    break;
                  case FilterComboboxEnumKey.PreviousYear:
                    item.inputValueCustom = this.$t("i18nCommon.LastYear");
                    break;
                  case FilterComboboxEnumKey.Tomorrow:
                    item.inputValueCustom = this.$t("i18nCommon.Tomorrow");
                    break;
                  case FilterComboboxEnumKey.NextWeek:
                    item.inputValueCustom = this.$t("i18nCommon.NextWeek");
                    break;
                  case FilterComboboxEnumKey.NextMonth:
                    item.inputValueCustom = this.$t("i18nCommon.NextMonth");
                    break;
                  case FilterComboboxEnumKey.NextYear:
                    item.inputValueCustom = this.$t("i18nCommon.NextYear");
                    break;
                }

                let startDate = moment(item.fromDate).format(
                  "YYYY-MM-DD HH:mm:ss"
                );
                let endDate = moment(item.toDate).format("YYYY-MM-DD HH:mm:ss");

                var renderItemTitle = `${
                  item.dataName
                } ${self.$function.handleLocalize(
                  item.operatorName
                )} ${self.$function.handleLocalize(item.inputValueCustom)}`;
                var renderItem = `<b>${
                  item.dataName
                }</b> ${self.$function.handleLocalize(
                  item.operatorName
                )} <b>${self.$function.handleLocalize(
                  item.inputValueCustom
                )}</b>`;
                if (item.operator == FilterComboboxEnumKey.Between) {
                  renderItemTitle = `${item.dataName} ${this.$t(
                    "i18nCommon.from"
                  )} ${formatDateTimeString(item.fromDate)} ${this.$t(
                    "i18nCommon.to"
                  )} ${formatDateTimeString(item.toDate)}`;
                  renderItem = `<b>${item.dataName}</b> ${this.$t(
                    "i18nCommon.from"
                  )} <b>${formatDateTimeString(item.fromDate)}</b> ${this.$t(
                    "i18nCommon.to"
                  )} <b>${formatDateTimeString(item.toDate)}</b>`;
                }
                switch (item.operator) {
                  case FilterComboboxEnumKey.NotEqual:
                    if (i < listFilter.length - 1) {
                      filter += `["${item.filterID}", "<", "${startDate}"], "OR", ["${item.filterID}", ">", "${endDate}"], "AND",`;
                    } else {
                      filter += `["${item.filterID}", "<", "${startDate}"], "OR", ["${item.filterID}", ">", "${endDate}"]`;
                    }
                    break;
                  case FilterComboboxEnumKey.Greater:
                    if (i < listFilter.length - 1) {
                      filter += `["${item.filterID}", ">", "${endDate}"], "AND",`;
                    } else {
                      filter += `["${item.filterID}", ">", "${endDate}"]`;
                    }
                    break;
                  case FilterComboboxEnumKey.GreaterAndEqual:
                    if (i < listFilter.length - 1) {
                      filter += `["${item.filterID}", ">=", "${startDate}"], "AND",`;
                    } else {
                      filter += `["${item.filterID}", ">=", "${startDate}"]`;
                    }
                    break;
                  case FilterComboboxEnumKey.Less:
                    if (i < listFilter.length - 1) {
                      filter += `["${item.filterID}", "<", "${startDate}"], "AND",`;
                    } else {
                      filter += `["${item.filterID}", "<", "${startDate}"]`;
                    }
                    break;
                  case FilterComboboxEnumKey.LessAndEqual:
                    if (i < listFilter.length - 1) {
                      filter += `["${item.filterID}", "<=", "${endDate}"], "AND",`;
                    } else {
                      filter += `["${item.filterID}", "<=", "${endDate}"]`;
                    }
                    break;
                  default:
                    if (i < listFilter.length - 1) {
                      filter += `["${item.filterID}", ">=", "${startDate}"], "AND", ["${item.filterID}", "<=", "${endDate}"], "AND",`;
                    } else {
                      filter += `["${item.filterID}", ">=", "${startDate}"], "AND", ["${item.filterID}", "<=", "${endDate}"]`;
                    }
                    break;
                }
                generatedOptions.push({
                  renderItemTitle: renderItemTitle,
                  renderItem: renderItem,
                  item: item,
                });
              } else {
                filter += `["${item.filterID}", "=", ""]`;
                item.inputValueCustom = `"${this.$t("i18nCommon.Empty")}"`;
                generatedOptions.push({
                  renderItemTitle: `${
                    item.dataName
                  } ${self.$function.handleLocalize(
                    item.operatorName
                  )} ${self.$function.handleLocalize(item.inputValueCustom)}`,
                  renderItem: `<b>${
                    item.dataName
                  }</b> ${self.$function.handleLocalize(
                    item.operatorName
                  )} <b>${self.$function.handleLocalize(
                    item.inputValueCustom
                  )}</b>`,
                  item: item,
                });
              }
            }
            // Nếu operator là Trống hoặc Không trống hoặc là Trong khoảng
            else {
              // Nếu operator là Trống
              if (item.operator == FilterComboboxEnumKey.Empty) {
                if (i < listFilter.length - 1) {
                  filter += `["${item.filterID}", "isnull"], "AND",`;
                } else {
                  filter += `["${item.filterID}", "isnull"]`;
                }
                generatedOptions.push({
                  renderItemTitle: `${item.dataName} ${this.$t(
                    "i18nCommon.Equal"
                  )} "${this.$t("i18nCommon.Empty")}"`,
                  renderItem: `<b>${item.dataName}</b> ${this.$t(
                    "i18nCommon.Equal"
                  )} <b>"${this.$t("i18nCommon.Empty")}"</b>`,
                  item: item,
                });
              }
              // Nếu operator là Không trống
              else if (item.operator == FilterComboboxEnumKey.NotEmpty) {
                if (i < listFilter.length - 1) {
                  filter += `["${item.filterID}", "notnull"], "AND",`;
                } else {
                  filter += `["${item.filterID}", "notnull"]`;
                }
                generatedOptions.push({
                  renderItemTitle: `${item.dataName} ${this.$t(
                    "i18nCommon.Equal"
                  )} "${this.$t("i18nCommon.NotEmpty")}"`,
                  renderItem: `<b>${item.dataName}</b> ${this.$t(
                    "i18nCommon.Equal"
                  )} <b>"${this.$t("i18nCommon.NotEmpty")}"</b>`,
                  item: item,
                });
              }
            }
          }
        });
        filter += "]";
        if (filter == "[]") {
          filter = null;
        } else {
          filter = this.$function.b64EncodeUnicode(filter);
        }
      } else {
        filter = null;
      }
      if (saveFilter) {
        this.saveFilter(this.customOptions);
      }
      this.filterCount = this.customOptions
        ? this.customOptions.filter((x) => x.isChecked).length
        : 0;
      this.$emit("onFilter", {
        base64: filter,
        options: this.customOptions.filter((e) => e.isChecked),
        callAPI,
      });
      this.$emit("onApply", generatedOptions);
      this.isShowSaveFilterBtn = true;
    },
    /**
     * Hàm lưu bộ lọc
     * created by pdthien 25.01.2021
     */
    saveFilter(dataFilter) {
      let data = dataFilter;
      if (dataFilter && dataFilter.length > 0) {
        data = [];
        dataFilter.forEach((e) => {
          if (e.isChecked) {
            data.push({
              valueField: e.valueField,
              showInput: e.showInput,
              toDate: e.toDate,
              fromDate: e.fromDate,
              inputValue: e.inputValue,
              inputValueCustom: e.inputValueCustom,
              isChecked: e.isChecked,
              operator: e.operator,
              operatorName: e.operatorName,
              initText: e.initText,
              initItems: e.initItems,
            });
          }
        });
      }
      // update dữ liệu trong store
      let userInfor = this.$store.getters.userInfor;
      userInfor.UserOptions[this.filterCode] = data ? _cloneDeep(data) : null;
      this.$store.dispatch("updateUserInfor", userInfor);
      // gọi API lưu vào db
      let option = {};
      option[this.filterCode] = data;
      this.$bus.$emit("saveFilter", option);
    },
    /**
     * Hàm xử lý khi đóng bộ lọc
     * created pdthien 24.12.2020
     */
    clickClose(isClearFilter = false) {
      this.showFilterX = false;
      this.$emit("closeFilter", isClearFilter);
    },
    /**
     * Hàm xử lý khi thay đổi chọn combobox chọn ngày
     * created by pdthien 24.12.2020
     */
    changeCbDate(val, item) {
      let ID = val.newData.ID;
      item.showInput = val.newData.ShowInput;
      item.betweenDate = val.newData.BetweenDate;
      switch (ID) {
        case 3:
          break;
        case 9: // Hôm nay
          item.fromDate = new Date();
          item.toDate = new Date();
          item.showInput = false;
          break;
        case 10: // Tuần này
          var curr = new Date(); // get current date
          var first = curr.getDate() - curr.getDay() + 1; // First day is the day of the month - the day of the week
          var last = first + 6; // last day is the first day + 6
          var firstday = new Date(new Date().setDate(first));
          var lastday = new Date(new Date().setDate(last));
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 11: // Tháng này
          var date = new Date();
          var firstday = new Date(date.getFullYear(), date.getMonth(), 1);
          var lastday = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 12: // Năm nay
          var date = new Date();
          var firstday = new Date(date.getFullYear(), 0, 1);
          var lastday = new Date(date.getFullYear(), 12, 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 13: // Hôm qua
          var curr = new Date(); // get current date
          var first = curr.getDate() - 1;
          var last = curr.getDate() - 1;
          var firstday = new Date(new Date().setDate(first));
          var lastday = new Date(new Date().setDate(last));
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 14: // Tuần trước
          var curr = new Date(); // get current date
          var first = curr.getDate() - curr.getDay() + 1 - 7;
          var last = first + 6;
          var firstday = new Date(new Date().setDate(first));
          var lastday = new Date(new Date().setDate(last));
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 15: // Tháng trước
          var date = new Date();
          var firstday = new Date(date.getFullYear(), date.getMonth() - 1, 1);
          var lastday = new Date(date.getFullYear(), date.getMonth(), 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 16: // Năm trước
          var date = new Date();
          var firstday = new Date(date.getFullYear() - 1, 0, 1);
          var lastday = new Date(date.getFullYear() - 1, 12, 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 17: // Ngày mai
          var date = new Date();
          date.setDate(date.getDate() + 1);
          item.fromDate = date;
          item.toDate = date;
          break;
        case 18: // Tuần sau
          var curr = new Date(); // get current date
          var first = curr.getDate() - curr.getDay() + 1 + 7;
          var last = first + 6;
          var firstday = new Date(new Date().setDate(first));
          var lastday = new Date(new Date().setDate(last));
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 19: // Tháng sau
          var date = new Date();
          var firstday = new Date(date.getFullYear(), date.getMonth() + 1, 1);
          var lastday = new Date(date.getFullYear(), date.getMonth() + 2, 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 20: // Năm sau
          var date = new Date();
          var firstday = new Date(date.getFullYear() + 1, 0, 1);
          var lastday = new Date(date.getFullYear() + 1, 12, 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 21:
          break;
      }
      item.operatorName = val.newData.Text;
      this.handleSelectDirect(item.operator);
    },
    /**
     * Hàm xử lý khi thay đổi chọn combobox chọn tháng
     * created by pdthien 24.12.2020
     */
    changeCbMonth(val, item) {
      let ID = val.newData.ID;
      item.showInput = val.newData.ShowInput;
      item.betweenDate = val.newData.BetweenDate;
      switch (ID) {
        case 9: // Tháng này
          var date = new Date();
          var firstday = new Date(date.getFullYear(), date.getMonth(), 1);
          var lastday = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 10: // Năm nay
          var date = new Date();
          var firstday = new Date(date.getFullYear(), 0, 1);
          var lastday = new Date(date.getFullYear(), 12, 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 11: // Tháng trước
          var date = new Date();
          var firstday = new Date(date.getFullYear(), date.getMonth() - 1, 1);
          var lastday = new Date(date.getFullYear(), date.getMonth(), 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 12: // Năm trước
          var date = new Date();
          var firstday = new Date(date.getFullYear() - 1, 0, 1);
          var lastday = new Date(date.getFullYear() - 1, 12, 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 13: // Tháng sau
          var date = new Date();
          var firstday = new Date(date.getFullYear(), date.getMonth() + 1, 1);
          var lastday = new Date(date.getFullYear(), date.getMonth() + 2, 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
        case 14: // Năm sau
          var date = new Date();
          var firstday = new Date(date.getFullYear() + 1, 0, 1);
          var lastday = new Date(date.getFullYear() + 1, 12, 0);
          item.fromDate = firstday;
          item.toDate = lastday;
          break;
      }
      item.operatorName = val.newData.Text;
      this.handleSelectDirect(item.operator);
    },
    /**
     * Hàm xử lý khi thay đổi chọn combobox cho input text
     * created by pdthien 04.01.2021
     */
    changeCbText(val, item) {
      item.showInput = val.newData.ShowInput;
      item.operatorName = val.newData.Text;
      this.handleSelectDirect(item.operator);
    },
    /**
     * Hàm xử lý khi thay đổi chọn combobox cho input number
     * created by pdthien 04.01.2021
     */
    changeCbNumber(val, item) {
      item.showInput = val.newData.ShowInput;
      item.operatorName = val.newData.Text;
      this.handleSelectDirect(item.operator);
    },
    /**
     * Hàm xử lý khi thay đổi chọn combobox cho input bool
     * created by pdthien 04.01.2021
     */
    changeCbBool(val, item) {
      item.showInput = val.newData.ShowInput;
      item.operatorName = val.newData.Text;
      this.handleSelectDirect(item.operator);
    },
    /**
     * Hàm xử lý khi thay đổi chọn combobox cho input combobox
     * created by pdthien 04.01.2021
     */
    changeCbCombobox(val, item) {
      item.showInput = val.newData.ShowInput;
      item.operatorName = val.newData.Text;
      this.handleSelectDirect(item.operator);
    },
    /**
     * Hàm xử lý khi thay đổi chọn ngày
     * created by pdthien 24.12.2020
     */
    changeDatePicker(val, item) {
      // set combobox về Tùy chọn
      if (val && val.newData) {
        item.operatorName = val.newData.Text;
      }

      // validate time
      if (item.fromDate > item.toDate) {
        item.errorValidate = true;
      } else {
        item.errorValidate = false;
      }
    },
    /**
     * Hàm xử lý khi thay đổi chọn combobox cho input time
     * created by pdthien 08.01.2021
     */
    changeCbTime(val, item) {
      item.showInput = val.newData.ShowInput;
      item.operatorName = val.newData.Text;
      this.handleSelectDirect(item.operator);
    },
    /**
     * Hàm khởi tạo cho custom option_ child of < initOptions < created
     * created by pdthien 09.06.2021
     */
    initCustomOptions(option, index) {
      return {
        ...option,
        index: index,
        isChecked: option.isChecked,
        operator: option.operator
          ? option.operator
          : this.getInitOperatorCombo(option.filterType).Value,
        operatorName: option.operatorName
          ? option.operatorName
          : this.getInitOperatorCombo(option.filterType).Text,
        inputValue: option.inputValue ? option.inputValue : null,
        inputValueCustom: option.inputValueCustom
          ? option.inputValueCustom
          : null,
        fromDate: option.fromDate
          ? option.fromDate // nvcuong1 sửa init date mặc định
          : this.filterType == "month"
          ? new Date(new Date().setDate(1))
          : new Date(),
        toDate: option.toDate
          ? option.toDate // nvcuong1 sửa init date mặc định
          : this.filterType == "month"
          ? new Date(new Date().setDate(1))
          : new Date(),
        filterType: option.filterType || null,
        showInput: option.showInput == false ? false : true,
        filterID: option.filterID ? option.filterID : option.valueField,
        doQueryFuntion: option.doQueryFuntion || null,
        initText: option.initText || null,
        initItems: option.initItems || null,
      };
    },
    // nvcuong1 thêm hàm check userInfor đã lưu bộ lọc chưa?
    checkUserOptionHadSaveFilter(userInfor) {
      const isUsingUserOption = false;

      const isUserOptionHadSaveFilter =
        isUsingUserOption &&
        !this.resetFilter &&
        this.filterCode &&
        userInfor.UserOptions &&
        userInfor.UserOptions[this.filterCode] &&
        userInfor.UserOptions[this.filterCode].length > 0;
      return isUserOptionHadSaveFilter;
    },
    /**
     * Hàm khởi tạo options
     * created by pdthien 13.01.2021, refactor by nvcuong1
     */
    initOptions() {
      let userInfor = this.$store.getters.userInfor;

      if (this.checkUserOptionHadSaveFilter(userInfor)) {
        this.customOptions = this.setCustomOption(userInfor);
        // chỉnh lại value cho option
        this.transformOptionItemComplex();
      } else {
        // tạo option và custom options
        let optionsTemp = this.$function._cloneDeep(this.options);
        this.customOptions = [];
        optionsTemp.forEach((o, index) => {
          this.customOptions.push(this.initCustomOptions(o, index));
        });

        // chỉnh lại value cho option
        this.transformOptionItemComplex();

        // this.filterCode && this.saveFilter(this.customOptions);
      }
      // this.handleApplyClick(false, false);
    },
    // nvcuong1 tách hàm set option custom
    setCustomOption(userInfor) {
      let optionsFromUserOption = _cloneDeep(
        userInfor.UserOptions[this.filterCode]
      );
      let customOptions = [];
      this.$function._cloneDeep(this.options).forEach((option, index) => {
        let customOption = this.initCustomOptions(option, index);

        // gán giá trị có từ userOptions
        optionsFromUserOption.forEach((optionFromUserOption) => {
          if (
            option.valueField &&
            option.valueField == optionFromUserOption.valueField
          ) {
            customOption = { ...customOption, ...optionFromUserOption };
          }
        });
        customOptions.push(customOption);
      });
      return customOptions;
    },
    transformOptionItemComplex() {
      this.customOptions.forEach((e) => {
        // chỉnh lại value combo
        if (e.filterType == "combobox-multiple") {
          e.inputValue &&
            e.inputValue.includes(";") &&
            (e.inputValue = e.inputValue.split(";"));
        }
        // nếu có value date
        if (e.fromDate && typeof e.fromDate == "string")
          e.fromDate = new Date(e.fromDate);
        if (e.toDate && typeof e.toDate == "string")
          e.toDate = new Date(e.toDate);
      });
    },
    /**
     * Hàm xử lý khi chọn dữ liệu trong combobox
     * created by pdthien 25.01.2021
     */
    onChangeCombobox(val, item) {
      item.initText = val;
      if (item && val) {
        item.inputValueCustom = val;
      }
    },
    /**
     * Hàm xử lý khi chọn dữ liệu trong combobox multiple
     * created by pdthien 25.01.2021
     */
    onChangeComboboxMultiple({ newListData }, item) {
      item.initItems = newListData;
      if (newListData && newListData.length > 0) {
        item.inputValueCustom = newListData
          .map((d) => d[item.dataField])
          .join("; ");
      } else {
        item.inputValueCustom = null;
      }
    },
    /**
     * Hàm xử lý khi click checkbox
     * created by pdthien 25.01.2021
     */
    onChangeCheckbox(val, item) {
      if (!val) {
        item.isChecked = false;
        item.operator = FilterComboboxEnumKey.Equal;
        item.inputValue = null;
        item.inputValueCustom = null;
        item.fromDate =
          this.filterType == "month"
            ? new Date(new Date().setDate(1))
            : new Date();
        item.toDate =
          this.filterType == "month"
            ? new Date(new Date().setDate(1))
            : new Date();
        item.initText = null;
        item.initItems = null;
        item.showInput = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
label {
  font-weight: 400 !important;
  color: #171b2a !important;
}
.container {
  padding: 3px 0 0 32px !important;
}
h2 {
  font-weight: 500;
}
.ms-button-text {
  font-weight: 400;
}
.filter {
  position: relative;
  background: #fff;
  border-radius: 4px;
  width: 240px;
  min-width: 240px;
  height: calc(100vh - 61px);
  // border: 1px solid #e0e0e0;
}
.filter .header {
  padding: 14px 16px 0 16px;
}
.close-btn,
.show-btn {
  cursor: pointer;
}
.px-4 {
  padding: 0 4px !important;
}
.checkedItem {
  background: var(--primary-bg);
  border-radius: 4px;
}
.cursor-pointer {
  cursor: pointer;
}

.filter-condition {
  max-height: calc(100% - 158px);
  overflow-y: auto;
  padding: 0 8px 12px 8px;
  height: calc(100vh - 240px);
}
.filter-button {
  bottom: 0px;
  width: 100%;
  height: 60px;
  position: absolute;
  left: 10px;
  bottom: 0;
  //margin-left: 100px;
}

.avatar-custom-filter {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  min-width: 32px;
}

.user-custom-filter {
  width: 200px;
  display: flex;
  align-items: center;
}

.user-info {
  width: 160px;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .item-user-in-popup-filter {
    height: 22px;
    flex: unset !important;
  }
}

// @media only screen and (min-width: 1030px) and (max-width: 1366px) {
//   .filter-condition {
//     //@errorheight: 410px;
//     max-height: calc(100vh - 158px);
//     overflow-y: auto;
//     padding: 0 8px 12px 8px;
//   }
//   .filter-button {
//     bottom: 0px;
//     width: 100%;
//     height: 60px;
//     margin-left: 110px;
//     position: absolute;
//     left: 24px;
//     bottom: 0;
//   }
// }

// @media only screen and (min-width: 1368px) and (max-width: 1920px) {
//   .filter-condition {
//     // height: 720px;
//     max-height: calc(100vh - 158px);
//     overflow-y: auto;
//     padding: 0 8px 12px 8px;
//   }
//   .filter-button {
//     bottom: 0px;
//     width: 100%;
//     height: 60px;
//     position: absolute;
//     left: 24px;
//     bottom: 0;
//     //margin-left: 100px;
//   }
// }
</style>
